const getZoomNumber = ({
  internationalNumbers,
  tollFreeNumbers
}) => {
  if (tollFreeNumbers) {
    const tollFreeNums = tollFreeNumbers.split(',');
    if (tollFreeNums.length) return tollFreeNums[0];
  }

  if (internationalNumbers) {
    const internationalNums = internationalNumbers.split(',');
    if (internationalNums.length) return internationalNums[0];
  }
};

export default getZoomNumber;